import request from '@/utils/request'


// 我的动态
export function getMyLog(params) {
    return request({
        url: '/api/myLog',
        method: 'post',
        data:params,
        isAuth:true
    })
}



// 我的档案
export function getMyArchives() {
    return request({
        url: '/api/myArchives',
        method: 'post',
        isAuth:true
    })
}

// 获取密码强度

export function getCheckPwd() {
    return request({
        url: '/api/getCheckPwd',
        method: 'post',
        isAuth:true
    })
}

// 获取学习流程接口
export function getLearningProcess(params) {
    return request({
      url: "/api/getLearningProcess",
      method: "get",
    });
  }

// 获取学习流程接口
export function getCommonProblem(params) {
    return request({
      url: "/api/getCommonProblem",
      method: "get",
    });
  }


// 获取学习流程接口
export function getMattersNeedingAttention(params) {
    return request({
      url: "/api/getMattersNeedingAttention",
      method: "get",
    });
  }

// 获取公告图片
export function getNoticeImage() {
    return request({
      url: "/api/getNoticeImage",
      method: "get",
    });
  }
// 获取公告列表
  export function getNoticeList(params) {
    return request({
      url: "/api/noticeList",
      method: "get",
      params
    });
  }

  // 获取公告详情
  export function getNoticeDetail(params) {
    return request({
      url: "/api/noticeDetail",
      method: "get",
      params
    });
  }